export default {
  path: 'winter-service/v2/requests/:id',
  name: 'WinterService2RequestDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RequestDetails.vue')
}
